import _ from 'underscore';
import { merge } from '@bingads-webui-universal/primitive-utilities';

import {
  GENERAL_INSIGHTS_PREFERENCES,
} from './consts';

export function getGeneralInsightsPreferences(preferencesService) {
  const sessionData = preferencesService.findByNameAtUserLevel(GENERAL_INSIGHTS_PREFERENCES);

  return _.result(sessionData, 'Data', {});
}

export function saveGeneralInsightsPreferences(preferencesService, data) {
  const Data = merge(
    {},
    getGeneralInsightsPreferences(preferencesService),
    data
  );

  preferencesService.setAtUserLevel({
    Name: GENERAL_INSIGHTS_PREFERENCES,
    Data,
  });
}
